import Axios from 'config/service.config'
import config from 'config/env_config'

export const getActiveCoupon = async () => {
  try {
    const { data } = await Axios({
      baseURL: config.partner,
      url: '/product-coupons/active'
    })
    return data
  } catch (error) {
    return error.response
  }
}
